<template>
  <!--<b-container class="section-form-container">-->
  <b-card>
    <h4 slot="header">
      Project Information
      <!--<b-button v-on:click="blernk()">Blernk</b-button>-->
    </h4>
    <b-form>
      <rx-text-entry-box
        id="projectName"
        v-model="projectName"
        title-text="Project Name"
        placeholder="Enter Project Name"
        description="Enter a name for your segment or project. It will be displayed in the final report."
        :validation="$v.projectName"
      />

      <rx-text-entry-box
        id="projectID"
        v-model="projectId"
        title-text="Project ID"
        placeholder="Enter optional Project ID"
        description="If applicable, provide the project identification number or other unique identifier."
        :validation="$v.projectId"
      />

      <rx-text-entry-box
        id="projectDescription"
        v-model="projectDescription"
        title-text="Project Description"
        placeholder="Enter optional project description"
        description="Enter additional information about the project."
        :validation="$v.projectDescription"
      />

      <rx-text-entry-box
        id="locationDescription"
        v-model="locationDescription"
        title-text="Location Description"
        placeholder="Enter optional location description"
        description="Enter additional information about the project location."
        :validation="$v.locationDescription"
      />

      <rx-text-entry-box
        id="owner"
        v-model="owner"
        title-text="Project Owner"
        description="Agency or organization that owns the segment or project"
        placeholder="Enter owner"
        :validation="$v.owner"
      />

      <rx-text-entry-box
        id="city"
        v-model="city"
        title-text="City"
        placeholder="Enter project city"
        description="Enter the name of the city in which the segment or project will be located"
        :validation="$v.city"
      />

      <rx-dropdown
        id="stateSelect"
        v-model="state"
        :options="stateOptions"
        description="Enter the name of the state in which the segment or project will be located"
        title-text="State"
        :dropdown-col-size="4"
        :validation="$v.state"
      />
    </b-form>
  </b-card>
  <!--</b-container>-->
</template>

<script>

  import { mapFields } from "vuex-map-fields";
  import { mapMutations, mapActions } from 'vuex'
  import { validationMixin } from 'vuelidate';
  import { required, between, minLength, maxLength } from 'vuelidate/lib/validators'

  import RxTextEntryBox from './inputComponents/RxTextEntryBox.vue'
  import RxDropdown from './inputComponents/RxDropdown.vue'
  import {isValidSection1} from "../../../js/validation/projectValidation";

  import { states } from "../../../js/stateAbbreviations";


  export default {
    name: "Section1",
    components: {
      RxTextEntryBox: RxTextEntryBox,
      RxDropdown: RxDropdown
    },
    mixins: [
      validationMixin
    ],
    props:{
      value:{

      }
    },
    data() {
      return {
        stateOptions: states
        // stateOptions: ['a', 'b', 'c']
      };
    },
    computed: {
      ...mapFields('rx',[
        "currentProject",
        "currentProject.projectName",
        "currentProject.projectId",
        "currentProject.city",
        "currentProject.state",
        "currentProject.owner",
        "currentProject.locationDescription",
        "currentProject.projectDescription",
        "currentPageValidationState"
      ])
    },
    methods:{
      ...mapMutations('rx',[
        'setValidSection',
        'setPageValidationState'
      ]),
      ...mapActions('rx',[
        'validateProjectState',
      ])
    },
    validations: {
      projectName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      projectId: {
        maxLength: maxLength(100)
      },
      projectDescription: {
        maxLength: maxLength(100)
      },
      locationDescription: {
        maxLength: maxLength(100)
      },
      city: {
        required,
        maxLength: maxLength(100)
      },
      state: {
        required
      },
      owner: {
        required,
        maxLength: maxLength(100)
      },
    },
    updated: function() {
      console.log("Section 1 field validators match store validation:",
        isValidSection1(this.currentProject) === !this.$v.$invalid);

      this.setValidSection({
        section: '1',
        value: !this.$v.$invalid
      });
    },
    beforeMount() {
      this.validateProjectState();
      this.setPageValidationState(this.$v)
    }
  };
</script>

<style scoped>
  .section-form-container {
    text-align: left;
  }

  label {
    text-align: center;
  }

</style>
